import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

import { Table } from 'gdpp-components/dist/cjs/components/molecules'
import { getGlobalParams } from 'config/config'

import Modal from '../../molecules/Modal'
import ErrorLogo from '../../../images/19_website_development.svg'
import './style.scss'

const HomepageLevelMessage = ({ type, monthlyDividendComparisonTable }) => {
  const intl = useIntl()
  const { baseUrl } = getGlobalParams()

  const titleTemplate = () => {
    let id = ''
    if (type) {
      switch (type) {
        case 'fundList':
        case 'fundDetail':
        case 'fundCompare':
          id = 'homepageDataErrorMessage.titleFund'
          break
        case 'dividend':
          id = 'homepageDataErrorMessage.titleDividend'
          break
        default:
          console.warn('There is no status')
      }
      return <FormattedMessage id={id} />
    }

    return ''
  }

  const dividendDateIntroLinkContent = (
    <Modal
      {...{
        triggerButtonConfig: {
          label: intl.formatMessage({ id: 'allDividendInfo.dividendDateIntroLinkContent' }),
          icon: ''
        },
        modalHeader: intl.formatMessage({ id: 'allDividendInfo.dividendDateIntroLinkContent' }),
        modalHeaderClasses: 'text-left',
        size: 'small',
        dialogContent: intl.formatMessage({ id: 'allDividendInfo.dividendIntroDialogContent' }),
        zIndex: 100
      }}
    />
  )

  const monthlyDividendComparisonLinkContent = (
    <Modal
      {...{
        triggerButtonConfig: {
          label: intl.formatMessage({ id: 'allDividendInfo.monthlyDividendComparisonLinkContent' }),
          icon: ''
        },
        modalHeader: intl.formatMessage({ id: 'allDividendInfo.monthlyDividendComparisonLinkContent' }),
        modalHeaderClasses: 'text-left',
        zIndex: 100
      }}
    >
      {monthlyDividendComparisonTable && (
        <Table
          tableId="dividend-date-intro-modal"
          {...{
            extraClasses: monthlyDividendComparisonTable.extraClasses,
            ...monthlyDividendComparisonTable.tableData
          }}
        />
      )}
    </Modal>
  )

  const contentTemplate = () => {
    let content = ''
    if (type) {
      switch (type) {
        case 'fundList':
        case 'fundCompare':
          content = (
            <FormattedMessage
              id="homepageDataErrorMessage.contentFund"
              values={{
                redirectHomepage: (
                  <a href="https://www.fidelity.com.tw" target="_blank" rel="noreferrer">
                    {intl.formatMessage({ id: 'homepageDataErrorMessage.contentHomepageLink' })}
                  </a>
                )
              }}
            />
          )
          break
        case 'dividend':
          content = (
            <FormattedMessage
              id="homepageDataErrorMessage.contentDividend"
              values={{
                dividendDateIntroLinkContent,
                monthlyDividendComparisonLinkContent,
                redirectFundlist: (
                  <span>
                    <br />
                    {intl.formatMessage({ id: 'homepageDataErrorMessage.contentVisitTo' })}
                    <a href={`${baseUrl}/funds`} target="_blank" rel="noreferrer">
                      {intl.formatMessage({ id: 'homepageDataErrorMessage.contentFundList' })}
                    </a>
                  </span>
                )
              }}
            />
          )
          break
        case 'fundDetail':
          content = (
            <FormattedMessage
              id="homepageDataErrorMessage.contentDetail"
              values={{
                redirectFundlist: (
                  <a href={`${baseUrl}/funds`} target="_blank" rel="noreferrer">
                    {intl.formatMessage({ id: 'homepageDataErrorMessage.contentFundList' })}
                  </a>
                )
              }}
            />
          )
          break
        default:
          console.warn('There is no status')
      }
      return content
    }

    return ''
  }

  return (
    <div className="fil-homepage-level-message">
      <div className="fil-homepage-level-message__icon">
        <img src={ErrorLogo} alt="" width="96" height="96" />
      </div>
      <div className="fil-homepage-level-message__title">{titleTemplate()}</div>
      <div className="fil-homepage-level-message__content">{contentTemplate()}</div>
    </div>
  )
}

HomepageLevelMessage.propTypes = {
  type: PropTypes.string,
  monthlyDividendComparisonTable: PropTypes.object
}

HomepageLevelMessage.defaultProps = {
  type: '',
  monthlyDividendComparisonTable: {}
}

export default HomepageLevelMessage
